import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroHighlights = ['6 Complete Visual Coaching Systems', '150 Ready-to-Coach Sessions', '5 Professional Bonus Guides', 'Immediate Digital Access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-blue-950" data-id="element-118" data-mp="1274l9hahx23j">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-119" data-mp="x8bcg265lz9p">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-120" data-mp="s9ggrzn38g86">
          <div className="inline-block px-3 py-1 rounded-full border border-amber-500/60 bg-white/5 text-amber-500 font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-121" data-mp="3d2tnz8hi2ie0">
            🏋️ OLYMPIC WEIGHTLIFTING COACH READY
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-white" data-id="element-122" data-mp="3o7vl7nivvtyv">
            Solve Your Olympic Weightlifting Coaching Sessions in Just{' '}
            <span className="text-amber-500" data-id="element-123" data-mp="3e8ei9dv0nu6l">5 MINUTES</span>
          </h1>

          <p className="text-sm sm:text-base md:text-lg text-white/80 max-w-3xl mx-auto mb-4 sm:mb-6" data-id="element-124" data-mp="30hhqfp8wzh0l">
            Olympic Weightlifting Coach Ready — The Complete 6-in-1 Visual Coaching System with{' '}
            <span className="text-amber-500 font-semibold" data-id="element-125" data-mp="2qkda461r2frp">150 Ready-to-Coach Sessions</span> and{' '}
            <span className="text-amber-500 font-semibold" data-id="element-126" data-mp="2vi54d6pvadz2">5 Professional Bonus Guides</span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[320px] sm:max-w-lg md:max-w-3xl mb-4 sm:mb-6" data-id="element-127" data-mp="2hjoy1gvx2phg">
          <img src={HERO_IMAGE} alt="Olympic Weightlifting Coach Ready complete system: 6 visual coaching systems, 150 ready-to-coach sessions and 5 professional bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-128" data-mp="naa0oqsklilz" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-129" data-mp="1azumdhg3ytyy">
          <p className="text-sm sm:text-base md:text-lg text-white font-semibold max-w-2xl mx-auto mb-2" data-id="element-130" data-mp="111eqz2a1syjn">
            Olympic Weightlifting Coach Ready Complete System:
          </p>
          <p className="text-sm sm:text-base text-amber-500 font-semibold max-w-2xl mx-auto mb-4 sm:mb-5" data-id="element-131" data-mp="3lu04j5ufbd1u">
            6 Visual Coaching Systems, 150 Ready-to-Coach Sessions and 5 Professional Bonus Guides
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-white/85 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-132" data-mp="1xavxukzeea7s">
            150 ready-to-coach Olympic Weightlifting sessions designed to help coaches plan less,
            teach technique with more structure, visually correct technical errors and develop
            athletes from beginner to advanced.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-133" data-mp="2g0ls96z90tz6">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-134" data-mp="2g256ks1cguyb">
              🟠 GET THE COMPLETE 6-IN-1 VISUAL WEIGHTLIFTING COACHING SYSTEM NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-white/70" data-id="element-135" data-mp="umhfqh2m8tqz">
            {heroHighlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-136" data-mp="zm2kj84gvwbm">
                <CheckCircle size={14} className="text-amber-500" data-id="element-137" data-mp="4acnbfstvv90" />
                <span data-id="element-138" data-mp="3vhxgzllx9bzl">{highlight}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}